import {fetchAndDeserialize} from '../../../util/api-adapter';
import {objectToUrlParameters} from '../../../util/url';
import {ReviewsAndAnswersFilterStateType} from '../filter/reviews-and-answers-statistics-filter-type';
import {reviewsAndAnswersApiFilterValues} from '../filter/reviews-and-answers-statistics-helper';

import {complaintsCountSchema, ComplaintsCountType} from './complaints-count-type';

export function fetchComplaintsCount(
    filter: ReviewsAndAnswersFilterStateType,
    mainFilterKey: string
): Promise<ComplaintsCountType> {
    return fetchAndDeserialize(
        `/cp/reviews/statistics/abuses/?${objectToUrlParameters(
            reviewsAndAnswersApiFilterValues(filter, mainFilterKey)
        )}`,
        complaintsCountSchema
    );
}
